export interface ISelectedService {
    uid: number
    [k: string]: any
}

export type IAmountable<T> = [number, T];

export interface IState {
    travelerNumber: number
    singleRoomAmount: number
    doubleRoomAmount: number
    mixedRoomAmount: number
    sharedDoubleRoomAmount: number
    commonDoubleRoomAmount: number
    hasError: boolean
    hasDataAdoptionError: boolean
    hasSharedDoubleRoom: boolean
    selectedServices: Array<IAmountable<ISelectedService>>
    contactData: {
        salutation: string
        firstname: string
        lastname: string
        country: string
        [k: string]: any
    }
    personalDataAdoptedTo: string
    prefix: string
}

export const initialState: IState = {
    travelerNumber: 0,
    singleRoomAmount: 0,
    doubleRoomAmount: 0,
    mixedRoomAmount: 0,
    sharedDoubleRoomAmount: 0,
    commonDoubleRoomAmount: 0,
    hasError: false,
    hasDataAdoptionError: false,
    hasSharedDoubleRoom: false,
    selectedServices: [],
    contactData: {
        salutation: '',
        firstname: '',
        lastname: '',
        country: ''
    },
    personalDataAdoptedTo: '',
    prefix: ''
};
